<div class="download-block--gray">
    <span class="download-block--gray--details--icon" data-ng-transclude="">
        <em class="icon icon--arrow-down-border"></em>
    </span>
    <div class="download-block--gray--details">
        <div [innerHTML]="downloadDescription | i18n"></div>
        <a 
            id="download_btn"
            data-tag-commander=""
            [appTagCommander]="'tagCo.documentselection-exp3.download.document.pij3001'"
            data-file-download-person-id="nextStepIntroduction.summaryExpectedMedicalDocuments.personId"
            data-file-download-proposition-id="nextStepIntroduction.summaryExpectedMedicalDocuments.propositionId"
            data-file-download-document-id="nextStepIntroduction.summaryExpectedMedicalDocuments.id"
            data-file-download-name="nextStepIntroduction.summaryExpectedMedicalDocuments.title"
            data-ng-model="nextStepIntroduction.summaryExpectedMedicalDocuments.downloaded"
            (click)="downloadFile()">{{ 'documentselection.documents.button.text' | i18n }}</a>
    </div>
</div>
